import { css } from '@emotion/react';
import { TXTColors, UTColors, GraphColors, ScrollColors } from './Colors';
import { LegacyColors } from './LegacyColors';
import { createColorsCssVariables, getColors } from './utils';

export const Colors = {
  ...LegacyColors,
  ut: getColors(UTColors, 'ut'),
  text: getColors(TXTColors, 'text'),
  graph: getColors(GraphColors, 'graph'),
  scroll: getColors(ScrollColors, 'scroll')
};

export const colorsLightCssVariables = css`
  ${createColorsCssVariables(UTColors, 'ut', 'light')};
  ${createColorsCssVariables(TXTColors, 'text', 'light')};
  ${createColorsCssVariables(GraphColors, 'graph', 'light')};
  ${createColorsCssVariables(ScrollColors, 'scroll', 'light')};
`;

export const colorsDarkCSSVariables = css`
  ${createColorsCssVariables(UTColors, 'ut', 'dark')};
  ${createColorsCssVariables(TXTColors, 'text', 'dark')};
  ${createColorsCssVariables(GraphColors, 'graph', 'dark')};
  ${createColorsCssVariables(ScrollColors, 'scroll', 'dark')};
`;
